<template>
  <div id="app">
    <el-container>
      <el-header class="custom-header">
        <div class="header-content">
          <div class="logo-container">
            <div class="logo">
              <i class="el-icon-game-controller"></i>
              <span class="logo-text">澄海3C电竞社区</span>
            </div>
          </div>
          <el-menu
            :default-active="activeIndex"
            class="custom-menu"
            mode="horizontal"
            @select="handleSelect"
            background-color="transparent"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-menu-item index="1">
              <router-link to="/" class="menu-link">
                <i class="el-icon-s-home"></i>
                <span>首页</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="2">
              <router-link to="/match" class="menu-link">
                <i class="el-icon-video-camera"></i>
                <span>约战</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="3">
              <router-link to="/game-buddy-list" class="menu-link">
                <i class="el-icon-headset"></i>
                <span>陪玩</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="4">
              <router-link to="/forum" class="menu-link">
                <i class="el-icon-document"></i>
                <span>论坛</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="5">
              <router-link to="/rank" class="menu-link">
                <i class="el-icon-medal"></i>
                <span>排行榜</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="6">
              <router-link to="/random-group" class="menu-link">
                <i class="el-icon-s-data"></i>
                <span>随机分组</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="7">
              <router-link to="/replay" class="menu-link">
                <i class="el-icon-video-play"></i>
                <span>精彩录像</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="8">
              <router-link to="/broadcast" class="menu-link">
                <i class="el-icon-camera"></i>
                <span>点播与赛事</span>
              </router-link>
            </el-menu-item>
            <!-- 管理员菜单 -->
            <el-submenu index="9" v-if="isAdmin">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span>管理中心</span>
              </template>
              <el-menu-item index="9-1">
                <router-link to="/admin/user-manager">用户管理</router-link>
              </el-menu-item>
              <el-menu-item index="9-2">
                <router-link to="/admin/game-buddy-manager">陪玩管理</router-link>
              </el-menu-item>
              <el-menu-item index="9-3">
                <router-link to="/admin/booking-manager">预约管理</router-link>
              </el-menu-item>
              <el-menu-item index="9-4">
                <router-link to="/admin/system-settings">系统设置</router-link>
              </el-menu-item>
            </el-submenu>
          </el-menu>
          <div class="user-container">
            <el-button
              v-if="!isLogin"
              type="primary"
              size="small"
              class="login-btn"
              @click="handleLogin"
            >
              <i class="el-icon-user"></i>
              登录
            </el-button>
            <div v-else class="user-info">
              <el-dropdown @command="handleDropdownCommand">
                <span class="user-dropdown">
                  <i class="el-icon-user-circle"></i>
                  <span>{{ username }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="user">个人中心</el-dropdown-item>
                  <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
      <el-main class="custom-main">
        <router-view />
      </el-main>
      <el-footer class="custom-footer">
        <div class="footer-content">
          <div class="footer-info">
            <p>© 2024 澄海3C电竞社区 版权所有</p>
            <p class="footer-links">
              <a href="#">关于我们</a> | 
              <a href="#">使用帮助</a> | 
              <a href="#">联系我们</a>
            </p>
          </div>
        </div>
      </el-footer>
    </el-container>
    
    <!-- 左侧固定聊天广场 -->
    <div class="sidebar-left" v-if="isLogin">
      <div class="sidebar-card">
        <div class="sidebar-header">
          <i class="el-icon-chat-dot-round"></i>
          <span>聊天广场</span>
        </div>
        <div class="chat-notice">
          <p>所有登录用户都可以文字聊天</p>
          <p class="warning">禁止非法内容</p>
        </div>
        <div class="chat-messages" ref="chatMessages">
          <div v-for="(msg, index) in chatMessages" :key="index" class="chat-message">
            <span class="chat-user">{{ msg.username }}：</span>
            <span class="chat-content">{{ msg.content }}</span>
            <span class="chat-time">{{ msg.time }}</span>
          </div>
          <div v-if="chatMessages.length === 0" class="no-message">
            暂无消息，快来发言吧！
          </div>
        </div>
        <div class="chat-input">
          <el-input
            v-model="chatInput"
            placeholder="输入消息..."
            size="small"
            @keyup.enter.native="sendMessage"
          >
            <el-button slot="append" icon="el-icon-s-promotion" @click="sendMessage"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    
    <!-- 右侧固定管理员信息 -->
    <div class="sidebar-right">
      <div class="sidebar-card">
        <div class="sidebar-header admin-header">
          <i class="el-icon-phone-outline"></i>
          <span>管理员联系方式</span>
        </div>
        <div class="admin-info">
          <div class="admin-item">
            <i class="el-icon-s-custom"></i>
            <span>管理员QQ：</span>
          </div>
          <div class="admin-qq">
            <a :href="'tencent://message/?uin=' + systemConfig.admin_qq" class="qq-link">{{ systemConfig.admin_qq }}</a>
          </div>
          <div class="admin-tip">
            <p>如有问题请联系管理员</p>
            <p>工作时间：9:00-22:00</p>
          </div>
        </div>
      </div>
      
      <!-- 赞助微信二维码 -->
      <div class="sidebar-card sponsor-card">
        <div class="sidebar-header sponsor-header">
          <i class="el-icon-present"></i>
          <span>赞助微信二维码</span>
        </div>
        <div class="sponsor-info">
          <div v-if="systemConfig.wechat_qrcode" class="qrcode-wrapper">
            <img :src="$axios.defaults.baseURL + systemConfig.wechat_qrcode" alt="微信赞助二维码" class="qrcode-img" />
          </div>
          <div v-else class="no-qrcode">
            <i class="el-icon-picture-outline"></i>
            <p>暂未设置</p>
          </div>
          <p class="sponsor-tip">感谢您的支持！</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeIndex: '',
      chatMessages: [],
      chatInput: '',
      systemConfig: {
        admin_qq: '2710741785',
        wechat_qrcode: ''
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // 根据当前路由更新activeIndex
        const routeMap = {
          '/': '1',
          '/match': '2',
          '/game-buddy-list': '3',
          '/forum': '4',
          '/forum/detail': '4',
          '/forum/post': '4',
          '/rank': '5',
          '/random-group': '6',
          '/replay': '7',
          '/broadcast': '8'
        }
        
        // 查找匹配的路由
        for (const [path, index] of Object.entries(routeMap)) {
          if (to.path === path || to.path.startsWith(path + '/')) {
            this.activeIndex = index
            return
          }
        }
        
        // 默认首页
        this.activeIndex = '1'
      }
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin
    },
    username() {
      return this.$store.state.username
    },
    isAdmin() {
      // 从 userInfo 中获取角色信息，roleId 为 1 表示管理员
      const userInfo = this.$store.state.userInfo || {}
      return this.$store.state.username === 'admin' || userInfo.roleId === 1 || userInfo.roleId === 0
    }
  },
  created() {
    this.$store.dispatch('getUserInfo')
    this.loadChatMessages()
    this.loadSystemConfig()
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key
    },
    handleLogin() {
      this.$router.push('/login')
    },
    handleDropdownCommand(command) {
      if (command === 'user') {
        // 添加路径检查，避免重复导航
        if (this.$route.path !== '/user') {
          this.$router.push('/user')
        }
      } else if (command === 'logout') {
        this.$store.dispatch('logout')
        // 添加路径检查，避免重复导航
        if (this.$route.path !== '/') {
          this.$router.push('/')
        }
      }
    },
    loadChatMessages() {
      // 调用后端API获取聊天记录
      this.$axios.get('/chat/messages').then(res => {
        if (res.code === 200) {
          this.chatMessages = res.data || []
        } else {
          this.chatMessages = [
            { username: '系统', content: '欢迎来到聊天广场！', time: '12:00' }
          ]
        }
      }).catch(error => {
        console.error('获取聊天记录失败:', error)
        this.chatMessages = [
          { username: '系统', content: '欢迎来到聊天广场！', time: '12:00' }
        ]
      })
    },
    loadSystemConfig() {
      this.$axios.get('/system/config').then(res => {
        if (res.code === 200) {
          this.systemConfig = res.data
        }
      }).catch(error => {
        console.error('获取系统配置失败:', error)
      })
    },
    sendMessage() {
      if (!this.isLogin) {
        this.$message.warning('请先登录后发言')
        return
      }
      
      if (!this.chatInput || !this.chatInput.trim()) {
        this.$message.warning('请输入消息内容')
        return
      }
      
      const userInfo = this.$store.state.userInfo || {}
      const messageData = {
        userId: userInfo.id,
        username: this.username,
        content: this.chatInput.trim()
      }
      
      // 调用后端API发送消息
      this.$axios.post('/chat/send', messageData).then(res => {
        if (res.code === 200) {
          // 使用后端返回的消息格式
          this.chatMessages.push(res.data)
          // 只保留最近10条消息
          if (this.chatMessages.length > 10) {
            this.chatMessages = this.chatMessages.slice(-10)
          }
          this.chatInput = ''
          this.$nextTick(() => {
            const container = this.$refs.chatMessages
            if (container) {
              container.scrollTop = container.scrollHeight
            }
          })
        } else {
          this.$message.error(res.message || '发送失败')
        }
      }).catch(error => {
        console.error('发送消息失败:', error)
        this.$message.error('发送消息失败')
      })
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  background-color: #f0f2f5;
  color: #303133;
  line-height: 1.6;
}

#app {
  min-height: 100vh;
}

.el-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 自定义头部样式 */
.custom-header {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: white;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 24px;
  gap: 0;
  white-space: nowrap;
  overflow: hidden;
}

/* 菜单容器占据中间空间 */
.header-content > .el-menu {
  flex: 1;
  min-width: 0;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
}

/* 用户容器靠右 */
.header-content > .user-container {
  margin-left: 16px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .custom-menu .el-menu-item {
    padding: 0 12px;
    font-size: 13px;
  }
  
  .custom-menu .el-menu-item .menu-link i {
    margin-right: 6px;
    font-size: 14px;
  }
}

@media (max-width: 992px) {
  .custom-menu {
    margin: 0 20px;
  }
  
  .custom-menu .el-menu-item {
    padding: 0 10px;
  }
  
  .custom-menu .el-menu-item span {
    display: none;
  }
  
  .custom-menu .el-menu-item .menu-link i {
    margin-right: 0;
    font-size: 16px;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  .logo i {
    font-size: 24px;
  }
}

/* 自定义logo样式 */
.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(255, 208, 75, 0.2), rgba(255, 208, 75, 0.1));
  box-shadow: 0 2px 8px rgba(255, 208, 75, 0.3);
}

.logo:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 208, 75, 0.4);
}

.logo i {
  font-size: 24px;
  margin-right: 8px;
  color: #ffd04b;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.logo-text {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* 自定义菜单样式 */
.custom-menu {
  background-color: transparent !important;
  border-bottom: none !important;
  flex: 1;
  margin: 0;
  justify-content: flex-start;
  position: relative;
}

/* 确保菜单项水平排列 */
.custom-menu .el-menu-item,
.custom-menu .el-submenu {
  flex-shrink: 0;
}

/* 隐藏滚动条但保留滚动功能 */
.custom-menu::-webkit-scrollbar {
  height: 0;
}

.custom-menu {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* 优化菜单容器，添加背景渐变和边框效果 */
.custom-menu::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 95%;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 208, 75, 0.3), transparent);
  border-radius: 2px;
  opacity: 0.6;
}

.custom-menu .el-menu-item {
  height: 64px;
  line-height: 64px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  position: relative;
  border-radius: 8px 8px 0 0;
  margin: 0 0px;
  overflow: hidden;
  min-width: 80px;
}

.custom-menu .el-menu-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffd04b, #ff9f43);
  transition: width 0.3s ease;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(255, 208, 75, 0.5);
}

.custom-menu .el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.custom-menu .el-menu-item:hover::after {
  width: 100%;
}

.custom-menu .el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
  border-top: 2px solid #ffd04b;
  box-shadow: 0 0 20px rgba(255, 208, 75, 0.2);
}

.custom-menu .el-menu-item.is-active::after {
  width: 100%;
  box-shadow: 0 0 15px rgba(255, 208, 75, 0.7);
}

.menu-link {
  display: flex;
  align-items: center;
  color: white !important;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 0 4px;
}

.menu-link i {
  margin-right: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.menu-link:hover {
  color: #ffd04b !important;
}

.custom-menu .el-menu-item:hover .menu-link i {
  transform: translateY(-2px);
  color: #ffd04b;
}

.custom-menu .el-menu-item.is-active .menu-link {
  color: #ffd04b !important;
}

.custom-menu .el-menu-item.is-active .menu-link i {
  color: #ffd04b;
  transform: translateY(-2px);
}

/* 管理员菜单样式 */
.custom-menu .el-submenu {
  margin: 0 0px;
  position: relative;
}

.custom-menu .el-submenu .el-submenu__title {
  height: 64px;
  line-height: 64px;
  color: white !important;
  background-color: transparent !important;
  padding: 0 16px !important;
  min-width: 100px !important;
  width: auto !important;
  font-size: 13px;
}

.custom-menu .el-submenu:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.custom-menu .el-submenu:hover .el-submenu__title {
  color: #ffd04b !important;
}

.custom-menu .el-submenu.is-active {
  background-color: rgba(255, 255, 255, 0.15) !important;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  border-radius: 8px 8px 0 0;
  border-top: 2px solid #ffd04b;
}

.custom-menu .el-submenu.is-active .el-submenu__title {
  color: #ffd04b !important;
}

/* 子菜单弹出样式 */
.el-menu--horizontal .el-submenu .el-menu {
  top: 64px;
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.98), rgba(21, 128, 224, 0.98)) !important;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  border-radius: 0 0 8px 8px;
  padding: 8px 0;
}

.el-menu--horizontal .el-submenu .el-menu-item {
  background-color: transparent !important;
  color: white !important;
  transition: all 0.3s ease;
  padding: 0 24px;
  height: 50px;
  line-height: 50px;
  margin: 0;
}

.el-menu--horizontal .el-submenu .el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: #ffd04b !important;
  transform: translateX(8px);
  box-shadow: none;
}

/* 下拉菜单样式 */
.el-dropdown-menu {
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.98), rgba(21, 128, 224, 0.98)) !important;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  overflow: hidden;
  padding: 8px 0;
}

.el-dropdown-menu__item {
  color: white !important;
  transition: all 0.3s ease;
  padding: 12px 24px;
  margin: 0;
}

.el-dropdown-menu__item:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: #ffd04b !important;
  transform: translateX(8px);
}

/* 用户容器样式 */
.user-container {
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
  align-items: center;
  padding-left: 24px;
}

/* 登录按钮样式 */
.login-btn {
  white-space: nowrap;
  background: linear-gradient(135deg, #ffd04b, #ff9f43);
  border: none;
  box-shadow: 0 2px 8px rgba(255, 208, 75, 0.4);
  transition: all 0.3s ease;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 208, 75, 0.6);
}

/* 用户下拉菜单样式 */
.user-dropdown {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-dropdown:hover {
  background: linear-gradient(135deg, rgba(255, 208, 75, 0.4), rgba(255, 159, 67, 0.4));
  border-color: rgba(255, 208, 75, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 208, 75, 0.5);
}

/* 优化用户下拉菜单文字颜色 */
.user-dropdown span {
  color: white !important;
  font-weight: 500;
  margin: 0 8px;
}

.user-dropdown i {
  color: white !important;
  font-size: 16px;
}

.user-dropdown:hover span,
.user-dropdown:hover i {
  color: white !important;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .custom-menu .el-menu-item {
    padding: 0 12px;
    font-size: 13px;
  }
  
  .custom-menu .el-menu-item .menu-link i {
    margin-right: 6px;
    font-size: 14px;
  }
}

@media (max-width: 992px) {
  .custom-menu {
    margin: 0 20px;
  }
  
  .custom-menu .el-menu-item {
    padding: 0 10px;
  }
  
  .custom-menu .el-menu-item span {
    display: none;
  }
  
  .custom-menu .el-menu-item .menu-link i {
    margin-right: 0;
    font-size: 16px;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  .logo i {
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .header-content {
    padding: 0 16px;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  .custom-menu {
    margin: 0 20px;
  }
  
  .custom-menu .el-menu-item {
    padding: 0 8px;
    font-size: 14px;
  }
  
  .menu-link span {
    display: none;
  }
  
  .menu-link i {
    margin-right: 0;
  }
}

/* 自定义主内容区域样式 */
.custom-main {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 24px;
  background-color: #f0f2f5;
}

/* 自定义底部样式 */
.custom-footer {
  background-color: #1890ff;
  color: white;
  padding: 30px 0;
  margin-top: auto;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-info {
  text-align: center;
}

.footer-info p {
  margin: 8px 0;
}

.footer-links {
  font-size: 14px;
  opacity: 0.8;
  margin-top: 12px;
}

.footer-links a {
  color: white;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.footer-links a:hover {
  opacity: 1;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    padding: 0 16px;
  }
  
  .logo-text {
    font-size: 18px;
  }
  
  .custom-menu {
    margin: 0 20px;
  }
  
  .custom-menu .el-menu-item {
    padding: 0 12px;
    font-size: 14px;
  }
  
  .menu-link span {
    display: none;
  }
  
  .menu-link i {
    margin-right: 0;
  }
}

/* 左侧固定侧边栏 - 聊天广场 */
.sidebar-left {
  position: fixed;
  left: 20px;
  top: 100px;
  width: 300px;
  z-index: 100;
}

/* 右侧固定侧边栏 - 管理员信息 */
.sidebar-right {
  position: fixed;
  right: 20px;
  top: 100px;
  width: 280px;
  z-index: 100;
}

.sidebar-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.sidebar-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.sidebar-header i {
  margin-right: 8px;
  font-size: 18px;
}

.sidebar-header.admin-header {
  color: #E6A23C;
}

/* 聊天广场样式 */
.chat-notice {
  background: #f5f7fa;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #606266;
}

.chat-notice .warning {
  color: #E6A23C;
  font-weight: bold;
  margin-top: 5px;
}

.chat-messages {
  height: 350px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 10px;
}

.chat-message {
  margin-bottom: 8px;
  padding: 6px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
}

.chat-user {
  color: #409EFF;
  font-weight: bold;
  margin-right: 4px;
}

.chat-content {
  color: #303133;
  word-break: break-all;
}

.chat-time {
  color: #909399;
  font-size: 10px;
  float: right;
}

.no-message {
  text-align: center;
  color: #909399;
  padding: 30px 0;
  font-size: 12px;
}

.chat-input {
  margin-top: 10px;
}

/* 管理员信息样式 */
.admin-info {
  text-align: center;
  padding: 10px 0;
}

.admin-item {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.admin-item i {
  color: #409EFF;
  margin-right: 4px;
}

.admin-qq {
  margin: 15px 0;
}

.qq-link {
  font-size: 26px;
  font-weight: bold;
  color: #409EFF;
  text-decoration: none;
}

.qq-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.admin-tip {
  margin-top: 15px;
  font-size: 11px;
  color: #909399;
  line-height: 1.8;
}

/* 赞助二维码样式 */
.sponsor-card {
  margin-top: 15px;
}

.sponsor-header {
  color: #67C23A;
}

.sponsor-info {
  text-align: center;
  padding: 5px 0;
}

.qrcode-wrapper {
  margin: 5px 0;
}

.qrcode-img {
  max-width: 260px;
  max-height: 260px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.no-qrcode {
  color: #909399;
  padding: 20px 0;
}

.no-qrcode i {
  font-size: 40px;
  margin-bottom: 10px;
}

.sponsor-tip {
  font-size: 12px;
  color: #67C23A;
  margin-top: 10px;
}
</style>